export default '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M16.12842,28.49967C9.16504,28.49967,3.5,22.83463,3.5,15.87076c0-4.9209,2.85254-9.29395,7.11084-11.36426c-0.40039,1.28711-0.60645,2.63477-0.60645,4.00488c0,7.43457,6.04883,13.4834,13.48389,13.4834c1.37012,0,2.71826-0.20605,4.00488-0.60645C25.42334,25.64713,21.04981,28.49967,16.12842,28.49967z" fill="none" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />\
</svg>'


